import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthData } from 'app/shared/models/class/auth/auth-data';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';

@Component({
  selector: 'app-form-sign-in',
  templateUrl: './form-sign-in.component.html',
  styleUrls: ['./form-sign-in.component.scss']
})
export class FormSignInComponent extends SubscriptionBaseComponent implements OnInit {

  @Input() title: string;
  @Input() action: string;
  @Input() component: string;

  loginForm: UntypedFormGroup;
  confirm = false;
  isLoading = false;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private authService: AuthService,
    public dialog: MatDialog
  ) { super() }

  ngOnInit(): void {
    this.initSub();
    this.initForm();
  }

  initSub(): void{
    this.subscription.add(
      this.authService.isLoadingAuth.subscribe((result) => {
        this.isLoading = result;
      })
    )
  }

  onSubmit(): void {
    // switch (this.action) {
    //   case 'user':
        const newUser = new AuthData(this.f.user.value, this.f.password.value);
        this.authService.login(newUser, this.component, this.action);
        if (this.authService.isAuth()) {

          this.confirm = true;
          // setTimeout(() => {
          //   this.dialog.closeAll();
          //   this.router.navigate(['/home']);
          // }, 2500);
        }

    //     break;
    //   case 'admin':
    //     this.router.navigate(['/admin']);
    //     break;
    //   default:
    //     break;
    // }
  }

  get f() {
    return this.loginForm.controls;
  }

  private initForm(): void {
    this.loginForm = this.formBuilder.group({
      user: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

}
